import type { DiscoveryFilters } from '../types/discoveryBadges';

export function filtersFromParams(params: URLSearchParams): DiscoveryFilters {
  const get = (k: string) => params.get(k) || undefined;
  return {
    search: get('q') || get('search'),
    year_min: get('year_min'),
    year_max: get('year_max'),
    make: get('make'),
    model: get('model'),
    chassis: get('chassis'),
    engine: get('engine'),
    transmission: get('transmission'),
    drivetrain: get('drivetrain'),
    build_status: get('build_status'),
    has_images: get('has_images'),
    has_awards: get('has_awards'),
    mod_brand: get('mod_brand'),
    mod_category: get('mod_category'),
    event_slug: get('event_slug'),
    award_title: get('award_title'),
    badge_category: get('badge_category'),
    club_slug: get('club_slug'),
    verified_club: get('verified_club'),
    certified: get('certified'),
    spec_key: get('spec_key'),
    spec_value: get('spec_value'),
    build_purpose: get('build_purpose'),
    doc_score_min: get('doc_score_min'),
    has_verified_dyno: get('has_verified_dyno'),
    has_performance_record: get('has_performance_record'),
    has_achievement: get('has_achievement'),
    has_shop_contributor: get('has_shop_contributor'),
    has_albums: get('has_albums'),
    power_min: get('power_min'),
    power_max: get('power_max'),
    ptw_min: get('ptw_min'),
    achievement: get('achievement'),
    sort_by: get('sort_by') || 'updated_at',
    sort_order: (get('sort_order') as 'asc' | 'desc') || 'desc',
    page: Number(get('page') || 1),
    limit: 20,
  };
}

export function filtersToSearchParams(filters: DiscoveryFilters): URLSearchParams {
  const next = new URLSearchParams();
  const map: Record<string, string | undefined> = {
    q: filters.search ? String(filters.search) : undefined,
    year_min: filters.year_min != null ? String(filters.year_min) : undefined,
    year_max: filters.year_max != null ? String(filters.year_max) : undefined,
    make: filters.make,
    model: filters.model,
    chassis: filters.chassis,
    engine: filters.engine,
    transmission: filters.transmission,
    drivetrain: filters.drivetrain,
    build_status: filters.build_status,
    has_images: filters.has_images ? String(filters.has_images) : undefined,
    has_awards: filters.has_awards ? String(filters.has_awards) : undefined,
    mod_brand: filters.mod_brand,
    mod_category: filters.mod_category,
    event_slug: filters.event_slug,
    award_title: filters.award_title,
    badge_category: filters.badge_category,
    club_slug: filters.club_slug,
    verified_club: filters.verified_club ? String(filters.verified_club) : undefined,
    certified: filters.certified ? String(filters.certified) : undefined,
    spec_key: filters.spec_key,
    spec_value: filters.spec_value,
    build_purpose: filters.build_purpose,
    doc_score_min: filters.doc_score_min != null ? String(filters.doc_score_min) : undefined,
    has_verified_dyno: filters.has_verified_dyno ? String(filters.has_verified_dyno) : undefined,
    has_performance_record: filters.has_performance_record
      ? String(filters.has_performance_record)
      : undefined,
    has_achievement: filters.has_achievement ? String(filters.has_achievement) : undefined,
    has_shop_contributor: filters.has_shop_contributor
      ? String(filters.has_shop_contributor)
      : undefined,
    has_albums: filters.has_albums ? String(filters.has_albums) : undefined,
    power_min: filters.power_min != null ? String(filters.power_min) : undefined,
    power_max: filters.power_max != null ? String(filters.power_max) : undefined,
    ptw_min: filters.ptw_min != null ? String(filters.ptw_min) : undefined,
    achievement: filters.achievement,
    sort_by: filters.sort_by,
    sort_order: filters.sort_order,
    page: filters.page && filters.page > 1 ? String(filters.page) : undefined,
  };
  Object.entries(map).forEach(([k, v]) => {
    if (v !== undefined && v !== '' && v !== 'false') next.set(k, v);
  });
  return next;
}
